import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import CarServiceHistoryMetaTags from "./component";
import { withRouter } from "react-router";

const mapStateToProps = ({
    meta: {meta}
}) => ({
    meta
});

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(CarServiceHistoryMetaTags));
